import { Suspense, lazy } from 'react';
import { jsx } from 'react/jsx-runtime';
import 'linaria';

// Countries and locales from LCID strings
const splitCode = code => {
  // e.g. fr-ca => ca
  if (code.indexOf('-') > -1) {
    return code.split('-');
  }

  // e.g. fr.ca => ca
  if (code.indexOf('.') > -1) {
    return code.split('.');
  }
  return [code, code];
};

// Maps a locale to a country code
const getCountryCode = code => {
  // always return china for chinese (zh) locale
  if (code.startsWith('zh')) {
    return 'cn';
  }

  // Otherwise return the country side of a locale code,
  return splitCode(code)[1].toLowerCase();
};
var getCountryCode$1 = getCountryCode;

/*
  Current flags:
  au
  cn
  fr
  de
  it
  no
  ru
  es
  gb
  us
*/

const importSvgIcon = code => {
  switch (code) {
    case 'au':
      return import('./flag-austria-275d47a0.js');
    case 'cn':
      return import('./flag-china-480d02a3.js');
    case 'fr':
      return import('./flag-france-b791f087.js');
    case 'de':
      return import('./flag-germany-8fb16235.js');
    case 'it':
      return import('./flag-italy-6ffc72de.js');
    case 'no':
      return import('./flag-norway-fe81642c.js');
    case 'ru':
      return import('./flag-russia-7325c4c9.js');
    case 'es':
      return import('./flag-spain-37174d71.js');
    case 'gb':
      return import('./flag-uk-70bd0028.js');
    case 'us':
      return import('./flag-usa-67fef196.js');
    default:
      return Promise.resolve({
        default: () => null
      });
  }
};

const SVGFlag = _ref => {
  let {
    code
  } = _ref;
  const parsedCode = getCountryCode$1(code);
  const Icon = /*#__PURE__*/lazy(() => importSvgIcon(parsedCode));
  return /*#__PURE__*/jsx(Suspense, {
    fallback: "",
    children: /*#__PURE__*/jsx(Icon, {})
  });
};
var SVGFlag$1 = SVGFlag;

// takes a country code and returns the emoji
// https://github.com/danalloway/react-country-flag/blob/master/src/index.js#L23

const base = 127397; // Root Unicode flags index

const getEmojiFlag = code => {
  return code.toUpperCase().replace(/./g, char => String.fromCodePoint(char.charCodeAt(0) + base));
};
var getEmojiFlag$1 = getEmojiFlag;

const emojiFonts = "e1sv2d0u";
const EmojiFlag = _ref => {
  let {
    code
  } = _ref;
  const parsedCode = getCountryCode$1(code);
  const flag = getEmojiFlag$1(parsedCode);
  return /*#__PURE__*/jsx("span", {
    className: emojiFonts,
    children: flag
  });
};
var EmojiFlag$1 = EmojiFlag;

export { EmojiFlag$1 as EmojiFlag, SVGFlag$1 as SVGFlag, getCountryCode$1 as getFlagCountryCode, getEmojiFlag$1 as getFlagEmojiCode, importSvgIcon as importSvgFlag };
